import { createApp } from 'vue';
import Vuelidate from '@vuelidate/core';
// import VueScrollTo from 'vue-scrollto';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import VueGtag from 'vue-gtag-next';
// import VCalendar from 'v-calendar';
// import FirebaseInitializer from './plugins/initFirebase.js';
import App from './App.vue';
import axios from './plugins/axios';
import './registerServiceWorker';
import router from './router';
import store from './store';

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store);
app.use(router);
app.use(Vuelidate);
// app.use(VueScrollTo);
// app.use(VueGtag, {
//   property: {
//     id: '',
//     router,
//   },
// });
// app.use(VCalendar, {});
app.mount('#app');

// const firebaseInitializer = new FirebaseInitializer(store._state.data.user, store.dispatch);

/** postMessageを受け取る */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    console.log('Received message from service worker:', event.data);
    /** 通知クリック時のリンクがあったときのrouter遷移 */
    if (event.data && event.data.type === 'navigate' && event.data.url) {
      router.push(event.data.url);
      store.dispatch('user/update');
    }
    // デバイスの通知を表示
    if (event.data.messageType === 'push-received' && Notification.permission === 'granted') {
      const notificationTitle = event.data.notification?.title;
      if (!notificationTitle) return;
      const notificationOptions = {
        body: event.data.notification.body,
        data: {
          clickLink: event.data.notification?.click_action || null,
        },
      };

      const notification = new Notification(notificationTitle, notificationOptions);
      // 通知に対してクリック時の処理を設定
      notification.onclick = (e) => {
        e.preventDefault();
        const clickAction = notificationOptions.data?.clickLink;
        if (clickAction) {
          // memo: window.href.locationだとリロードされwebsocketが切断されるため、router.pushを使用
          router.push(clickAction);
        }
        notification.close();
      };
    }
  });
}
